export default __webpack_public_path__ + "3a662fb82ce540003aa30eee889733d53fbff2a5045d1acbd24896d49208a55e.svg";